import http from '../utils/http';
import * as endpoints from '../constants/endpoints';

export const getBoostInfoList = async () => {
  const response = await http.get(endpoints.BOOST_PRICE);

  return response.data;
};
